// @flow

import React, { useContext } from 'react';

export type ProfileType = {
  data: {
    is_staff: boolean,
  },
} | null;
export type ProfileContextType = {
  isProfileLoading: boolean,
  profile: ProfileType,
};

const DEFAULT_VALUE: ProfileContextType = {
  isProfileLoading: false,
  profile: {
    data: {
      is_staff: false,
    },
  },
};

const ProfileContext = React.createContext(DEFAULT_VALUE);

export default ProfileContext;

export const useProfile = () => useContext(ProfileContext);
